<template>
  <div class="upload-btn-container">
    <img src="@/assets/uploadd.svg" class="img" />
    <button class="upload-btn">{{ text }}</button>
  </div>
</template>

<script>
  export default {
    name: 'uploadButton',
    props: {
      text: String,
      default: 'Upload'
    }
  }
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";

.upload-btn-container {
  display: flex;
  align-items: flex-end;
  .img {
    height: 25px;
    object-fit: contain;
  }
  .upload-btn {
    font-size: $font-size-small;
    min-width: 70px;
    padding: 0px 5px 0px 5px;
    height: 25px;
    margin-left: 5px;
    border-radius: 4px;
    border: solid 1px $color-primary;
    color: $color-primary;
  }
}
</style>
